import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  id: null,
  name: null,
  slug: null,
  logo_url: null,
  plan: null,                    // BASIC | PRO | CUSTOM
  plan_request_status: 'NONE',   // NONE | PENDING_PRO_APPROVAL | PENDING_CUSTOM_APPROVAL
  plan_expires_at: null,         // null = no expiry (Basic); ISO date string for Pro/Custom
  state: null,             // Indian state code for PT slab lookup
  fiscal_year_start: 'APRIL',
  timezone: 'Asia/Kolkata',
  settings: {},
  isLoaded: false,
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompany: (state, action) => {
      return { ...state, ...action.payload, isLoaded: true };
    },
    clearCompany: () => ({ ...initialState }),
    updateCompanySettings: (state, action) => {
      state.settings = { ...state.settings, ...action.payload };
    },
    updateCompanyPlan: (state, action) => {
      state.plan = action.payload;
    },
    setPlanRequestStatus: (state, action) => {
      state.plan_request_status = action.payload;
    },
  },
});

export const { setCompany, clearCompany, updateCompanySettings, updateCompanyPlan, setPlanRequestStatus } = companySlice.actions;
export default companySlice.reducer;

export const selectCompany = (state) => state.company;
export const selectCompanyName = (state) => state.company.name;
export const selectCompanyPlan = (state) => state.company.plan;
export const selectCompanyLogoUrl = (state) => state.company.logo_url;
export const selectCompanySettings = (state) => state.company.settings;
export const selectCompanyLoaded = (state) => state.company.isLoaded;
export const selectPlanRequestStatus = (state) => state.company.plan_request_status;
